import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import Modal from 'react-modal';
import SubEditPlacement from './EditPlacement';
import SubCustomDropdown from '../Common/CustomDropdown';
import SubEditEnrollment from '../Common/EditEnrollment';
import {convertDateToString} from '../Functions/ConvertDateToString';
import withRouter from '../Functions/WithRouter';

const careerMatchesIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/career-matches-icon-dark.png';
const deleteIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/delete-icon-dark.png';
const arrowIndicatorIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/arrow-indicator-icon.png';
const searchIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/search-icon.png";
const addIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/add-icon.png';
const eventIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/event-icon-blue.png';
const assignmentsIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/assignments-icon-blue.png';
const problemIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/problem-icon-blue.png';
const challengeIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/challenge-icon-blue.png';
const internIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/intern-icon-blue.png';
const opportunitiesIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/opportunities-icon-blue.png';
const programIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/course-icon-blue.png';
const hideIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/hide-icon.png";
const loadingGIF = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/loading-gif.gif';

class Enrollments extends Component {
    constructor(props) {
        super(props)

        this.state = {
            resLimit: 100,
            pageNumber: 1,
            resLimit: 100,
            pageCountStart: 0,
            pageCountEnd: 100,
            enrollmentCount: 0,

            enrollments: [],
            filteredEnrollments: [],

            programOptions: [],
            caseManagerOptions: [],
            categoryOptions: ['','Course','Program'],
            stageOptions: ['', 'Enrolled','Completed','Dropped'],
            subsidyEligibleOptions: ['','Yes','No'],
            cohortOptions: ['','1','2','3','4','5','6','7','8','9','10'],
            isCompletedOptions: ['','Yes','No'],

            searchString: '',
            postedBy: 'Anyone',
            postType: 'All',
            status: 'All',
            workFunction: 'All',
            industry: 'All',
            applications: 'All',
            readyForNewRound: 'All',
            location: 'All',
            department: 'All',
            submissionDeadline: 'All'

        }

        this.retrieveData = this.retrieveData.bind(this)
        this.pullEnrollments = this.pullEnrollments.bind(this)
        this.closeModal = this.closeModal.bind(this)

        this.renderEnrollments = this.renderEnrollments.bind(this)
        this.formChangeHandler = this.formChangeHandler.bind(this)
        this.renderSearchResults = this.renderSearchResults.bind(this)
        this.filteredEnrollments = this.filteredEnrollments.bind(this)
        this.sortEnrollments = this.sortEnrollments.bind(this)

        this.movePage = this.movePage.bind(this)
        this.passData = this.passData.bind(this)
    }

    componentDidMount() {

      this.retrieveData()
    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called ', this.props, prevProps)

      if (this.props.activeOrg !== prevProps.activeOrg || this.props.accountCode !== prevProps.accountCode) {
        this.retrieveData()
      }
    }

    retrieveData() {
      console.log('retrieveData called', this.props)

      const org = this.props.activeOrg
      const accountCode = this.props.accountCode

      let email = localStorage.getItem('email');
      let username = localStorage.getItem('username');
      let orgFocus = localStorage.getItem('orgFocus');
      let roleName = localStorage.getItem('roleName');
      let placementPartners = localStorage.getItem('placementPartners');

      if (email && org) {

        this.setState({ org, emailId: email, username, orgFocus, roleName, placementPartners, accountCode })
        this.pullEnrollments(org, this.state.pageNumber)

        const roleNames = ['Admin']
        Axios.get('/api/org/members', { params: { orgCode: org, roleNames } })
        .then((response) => {
          if (response.data.success) {
            console.log('Member query worked', response.data);

            if (response.data.members && response.data.members.length > 0) {

              let caseManagerOptions = response.data.members
              if (caseManagerOptions) {
                caseManagerOptions.unshift({})

                this.setState({ caseManagerOptions })

              }
            }

          } else {
            console.log('no members found', response.data.message)
          }
        }).catch((error) => {
            console.log('Members query did not work', error);
        });

        Axios.get('/api/programs', { params: { orgCode: org } })
        .then((response) => {
          if (response.data.success) {
            console.log('Member query worked', response.data);

            if (response.data.programs && response.data.programs.length > 0) {

              let programOptions = response.data.programs
              if (programOptions) {
                programOptions.unshift({})

                this.setState({ programOptions })

              }
            }

          } else {
            console.log('no members found', response.data.message)
          }
        }).catch((error) => {
            console.log('Members query did not work', error);
        });
      }
    }

    movePage(forward) {
      console.log('movePage called', forward, this.state.pageNumber)

      let pageNumber = this.state.pageNumber
      if (forward) {
        pageNumber = pageNumber + 1
      } else {
        pageNumber = pageNumber - 1
      }

      this.pullEnrollments(this.state.org, pageNumber)

    }

    pullEnrollments(orgCode, pageNumber) {
      console.log('pullEnrollments called: ', orgCode, pageNumber)

      this.setState({ isLoading: true })

      const resLimit = this.state.resLimit
      const skip = (pageNumber - 1) * this.state.resLimit

      Axios.get('/api/courses/enrollments', { params: { orgCode, resLimit, skip }})
      .then((response) => {
        console.log('Enrollments query attempted now', response.data);

        if (response.data.success) {
          console.log('Enrollmentss query worked')

          let enrollments = response.data.enrollments
          const filteredEnrollments = enrollments

          let pageCountStart = ((pageNumber - 1) * resLimit) + 1

          let pageCountEnd = enrollments.length
          if (pageNumber > 1) {
            pageCountEnd = ((pageNumber - 1) * resLimit) + enrollments.length
          }
          console.log('show pages: ', pageCountStart, pageCountEnd, skip, resLimit, pageNumber)

          this.setState({ enrollments, filteredEnrollments, pageCountStart, pageCountEnd, pageNumber, isLoading: false });

        } else {
          console.log('enrollments query did not work', response.data.message)
          this.setState({ isLoading: false });
        }

      }).catch((error) => {
          console.log('Enrollments query did not work for some reason', error);
      });

      Axios.get('/api/enrollments/count', { params: { orgCode }})
      .then((response) => {
        console.log('Enrollments query attempted now', response.data);

        if (response.data.success) {
          console.log('enrollments query worked')

          this.setState({ enrollmentCount: response.data.enrollmentCount });

        } else {
          console.log('enrollments query did not work', response.data.message)
        }

      }).catch((error) => {
          console.log('enrollments query did not work for some reason', error);
      });
    }

    formChangeHandler(event) {
      console.log('formChangeHandler clicked');

      if (event.target.name === 'eventDate') {

        const sortCriteria = { name: event.target.name, shortname: event.target.value }
        this.setState({ [event.target.name]: event.target.value, sortCriteria })
        this.sortEnrollments(event.target.name, event.target.value)

      } else if (event.target.name === 'sortSubmissionDeadline') {

        const sortCriteria = { name: 'submissionDeadline', shortname: event.target.value }
        this.setState({ submissionDeadline: event.target.value, sortCriteria })
        this.sortEnrollments('submissionDeadline', event.target.value)

      } else {

        const filterCriteria = { name: event.target.name, shortname: event.target.value }
        this.setState({ [event.target.name]: event.target.value, filterCriteria })

        if (event.target.name === 'searchString') {
          this.renderSearchResults(event.target.value)
        } else {
          // filter
          this.filteredEnrollments(event.target.name, event.target.value)
        }
      }
    }

    filteredEnrollments(name, value) {
      console.log('filteredEnrollments called', name, value)

      this.setState({ isLoading: true, errorMessage: null, successMessage: null })

      const searchString = null
      const filterString = null
      // const filters = [{ name: 'Employer Feedback', value: value, options: this.state.employerFeedbackOptions }]
      const filters = [{ name: name, value: value, options: null }]

      const defaultFilterOption = 'All'
      const index = 0
      const search = null
      const enrollments = this.state.enrollments
      const type = null
      const emailId = this.state.emailId
      const orgCode = this.state.org
      const roleName = this.state.roleName

      Axios.put('/api/enrollments/filter', {  searchString, filterString, filters, defaultFilterOption, index, search, enrollments, type, emailId, orgCode, roleName })
      .then((response) => {
        console.log('Enrollment filter query attempted', response.data);

          if (response.data.success) {
            console.log('enrollments filter query worked')

            const filteredEnrollments = response.data.enrollments
            let filtered = true
            if (filteredEnrollments.length === this.state.enrollmentCount) {
              filtered = false
            }
            this.setState({ filteredEnrollments, filtered, isLoading: false, searchString: '' })

          } else {
            console.log('enrollments filter query did not work', response.data.message)
            this.setState({ isLoading: false, errorMessage: response.data.message, filtered: false, filteredEnrollments: [] })

          }

      }).catch((error) => {
          console.log('enrollments filter query did not work for some reason', error);
          this.setState({ isLoading: false, errorMessage: error.toString() })

      });
    }

    sortEnrollments(name, value) {
      console.log('sortEnrollments called', name, value)

      this.setState({ isLoading: true, errorMessage: null, successMessage: null })

      let sortName = 'No Sort Applied'
      let sortString = null
      if (value) {
        sortName = name
        sortString = value
      }

      const defaultFilterOption = 'All'
      const index = 0
      const search = null
      const enrollments = this.state.enrollments
      const type = null
      const emailId = this.state.emailId
      const orgCode = this.state.org
      const roleName = this.state.roleName

      Axios.put('/api/enrollments/sort', {  sortName, sortString, defaultFilterOption, index, search, enrollments, type, emailId, orgCode, roleName })
      .then((response) => {
        console.log('enrollments sort query attempted', response.data);

          if (response.data.success) {
            console.log('enrollments sort query worked')

            const filteredEnrollments = response.data.enrollments
            let filtered = true
            if (filteredEnrollments.length === this.state.enrollmentCount) {
              filtered = false
            }
            this.setState({ isLoading: false, filtered, filteredEnrollments })

          } else {
            console.log('enrollments sort query did not work', response.data.message)
            this.setState({ isLoading: false, errorMessage: response.data.message, filtered: false, filteredEnrollments: [] })
          }

      }).catch((error) => {
          console.log('enrollments sort query did not work for some reason', error);
          this.setState({ isLoading: false, errorMessage: error.toString() })
      });
    }

    passData(type, data, deleteAction) {
      console.log('passData called', type, data, deleteAction)

      if (type === 'enrollment') {

        if (deleteAction) {
          let enrollments = this.state.enrollments

          if (enrollments && enrollments.length > 0) {
            for (let i = 1; i <= enrollments.length; i++) {
              if (enrollments[i - 1] && enrollments[i - 1]._id === data._id) {
                enrollments.splice(i - 1)
              }
            }
          }
          const filteredEnrollments = enrollments
          this.setState({ enrollments, filteredEnrollments })
        } else {
          // let pageNumber = this.state.pageNumber
          let pageNumber = 1
          this.pullEnrollments(this.state.org, pageNumber)
        }
      }
    }

    renderSearchResults(searchString) {
      console.log('renderSearchResults called')

      this.setState({ isLoading: true, errorMessage: null, successMessage: null })

      const self = this
      function officiallyFilter() {
        console.log('officiallyFilter called')

        const orgCode = self.state.org
        const resLimit = self.state.resLimit

        Axios.get('/api/enrollments/search', { params: { searchString, orgCode, resLimit }})
        .then((response) => {
          console.log('Enrollemnts search query attempted', response.data);

            if (response.data.success) {
              console.log('Enrollments search query worked')

              let filteredEnrollments = response.data.enrollments
              let filtered = true
              if (filteredEnrollments.length === self.state.enrollmentCount) {
                filtered = false
              }
              self.setState({ filteredEnrollments, filtered, isLoading: false })

            } else {
              console.log('Enrollments search query did not work', response.data.message)

              let filteredEnrollments = []
              self.setState({ filteredEnrollments, filtered: false, isLoading: false })

            }

        }).catch((error) => {
            console.log('Search query did not work for some reason', error);
            self.setState({ isLoading: false })
        });
      }

      const delayFilter = () => {
        console.log('delayFilter called: ')
        clearTimeout(self.state.timerId)
        self.state.timerId = setTimeout(officiallyFilter, 1000)
      }

      delayFilter();
    }

    renderEnrollments() {
      console.log('renderEnrollments called')
      let rows = [];

      for (let i = 1; i <= this.state.filteredEnrollments.length; i++) {
        // console.log(i);
        const item = this.state.filteredEnrollments[i - 1]
        const index = i - 1

        // <th>#</th>
        // <th>Name</th>
        // <th>Email</th>
        // <th>Course/Program Name</th>
        // <th>Category</th>
        // <th>Provider</th>
        // <th>Stage</th>
        // <th>Cohort</th>
        // <th>Case Manager</th>
        // <th>Is WIOA Eligible</th>
        // <th>Created At</th>

        rows.push(
          <tr key={"filteredEnrollments|" + index} className="auto-pointers" onClick={() => this.setState({ modalIsOpen: true, showEditEnrollment: true, selectedEnrollment: item })}>
            <td>{index + 1}</td>
            <td>{item.firstName} {item.lastName}</td>
            <td>{item.email}</td>
            <td>{item.courseName}</td>
            <td>{item.courseCategory}</td>
            <td>{item.courseSchoolName}</td>
            <td>{item.stage}</td>
            <td>{item.cohort}</td>
            {(item.caseManager) ? (
              <td>{item.caseManager.firstName} {item.caseManager.lastName}</td>
            ) : (
              <td> - </td>
            )}
            <td>{item.isSubsidyEligible}</td>
            <td>{convertDateToString(new Date(item.createdAt),'date-2')}</td>
          </tr>
        )

        // if (this.state.showModule) {
        //
        //
        //   // #, name (firstName + lastName), email, courseName, stage, isSubsidyEligible, cohort, courseCategory, courseSchoolName, caseManager, createdAt
        //
        // } else {
        //   rows.push(
        //     <div key={"filteredEnrollments|" + index}>
        //         <div>
        //           <button className="background-button full-width left-text" onClick={() => this.setState({ modalIsOpen: true, showEditEnrollment: true, selectedEnrollment: item })}>
        //             <span className="fixed-column-70">
        //               <img src={careerMatchesIconDark} alt="GC" className="image-50-fit top-margin-5 center-horizontally"/>
        //             </span>
        //             <span className={"calc-column-offset-160 left-padding"}>
        //               <div className="full-width">
        //                 <p className="heading-text-5">{item.firstName} {item.lastName} ({item.email})</p>
        //               </div>
        //
        //               <div className="half-spacer"/>
        //               <p className="description-text-1 description-text-color">{item.courseName} {item.courseSchoolName}{(item.cohort) && " | Cohort " + item.cohort}{(item.enrollmentType) && " | " + item.enrollmentType}{(item.stage) && " | " + item.stage}{(item.caseManager) && " | Assigned Case Manager: " + item.caseManager.firstName + " " + item.caseManager.lastName}{(item.isSubsidyEligible) ? " | Is WIOA Elible" : " | Is Not WIOA Elible"}</p>
        //             </span>
        //
        //             <div className="fixed-column-50 height-40" />
        //
        //             <div className="fixed-column-22">
        //               <div className="spacer" />
        //               <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className="arrow-indicator-icon"/>
        //             </div>
        //             <div className="clear" />
        //           </button>
        //
        //           {(item.successMessage) && (
        //             <div className="row-5 left-padding">
        //               <p className="description-text-2 cta-color full-width">{item.successMessage}</p>
        //             </div>
        //           )}
        //
        //           {(this.state.sortCriteria) && (
        //             <div className="row-5 left-padding">
        //               <p className="description-text-2 error-color full-width">{this.state.sortCriteria.name}: {this.state.sortCriteria.shortname}</p>
        //             </div>
        //           )}
        //
        //           {(this.state.filterCriteria) && (
        //             <div className="row-5 left-padding">
        //               <p className="description-text-2 error-color full-width">{this.state.filterCriteria.name}: {this.state.filterCriteria.shortname}</p>
        //             </div>
        //           )}
        //
        //         </div>
        //
        //         <div className="row-15">
        //           <hr />
        //         </div>
        //
        //     </div>
        //   )
        // }
      }

      return rows;
    }

    closeModal() {
      this.setState({ modalIsOpen: false, showEditEnrollment: false, selectedEnrollment: null });
    }

    render() {

      return (
          <div>
            {(this.state.enrollments) ? (
              <div>
                <div>
                  <div className="width-85-percent top-margin-2-percent max-width-1400 center-horizontally card">
                    <div>
                      <div className="calc-column-offset-65 right-padding">
                        <p className="heading-text-2">{(this.state.enrollmentCount > 1) && this.state.enrollmentCount + " "}Enrollments</p>
                      </div>

                      <div className="fixed-column-40">
                        <button className="background-button" onClick={() => this.setState({ modalIsOpen: true, showEditEnrollment: true })}>
                          <img src={addIcon} alt="GC" className="image-25-fit"/>
                        </button>
                      </div>
                      <div className={"fixed-column-25"}>
                        {(this.state.showFilters) ? (
                          <button type="button" className="background-button clear-padding clear-margin" onClick={() => this.setState({ showFilters: false })}>
                            <img src={hideIcon} alt="GC" className="image-25-fit"/>
                          </button>
                        ) : (
                          <button type="button" className="background-button clear-padding clear-margin" onClick={() => this.setState({ showFilters: true })}>
                            <img src={searchIcon} alt="GC" className="image-25-fit"/>
                          </button>
                        )}
                      </div>
                      <div className="clear" />
                    </div>

                    <p className="description-text-2 row-5 standard-color">Enrollments to courses and programs</p>
                  </div>

                  {(this.state.showFilters) && (
                    <div className="width-85-percent top-margin-2-percent max-width-1400 center-horizontally card">
                      <div>
                        <div className="standard-border full-width row-5 left-padding right-padding">
                          <div className="fixed-column-25 top-padding-8">
                            <img src={searchIcon} alt="GC" className="image-18-fit"/>
                          </div>
                          <div className="calc-column-offset-25">
                            <input type="text" className="text-field clear-border" placeholder="Search by enrollee name..." name="searchString" value={this.state.searchString} onChange={this.formChangeHandler}/>
                          </div>
                          <div className="clear" />
                        </div>

                        <div className="row-20">
                          <hr />
                        </div>

                        <div className="row-5">
                          <p className="heading-text-5">Filter</p>
                        </div>

                        <SubCustomDropdown dropdownTitle="Training Program" name="courseName" value={this.state.courseName} options={this.state.programOptions} optionSubKey={"title"} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>
                        <SubCustomDropdown dropdownTitle="Assigned Case Manager" name="caseManagerUsername" value={this.state.caseManagerUsername} options={this.state.caseManagerOptions} optionSubKey={"username"} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>
                        <SubCustomDropdown dropdownTitle="Category" name="courseCategory" value={this.state.courseCategory} options={this.state.categoryOptions} optionSubKey={null} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>
                        <SubCustomDropdown dropdownTitle="Stage" name="stage" value={this.state.stage} options={this.state.stageOptions} optionSubKey={null} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>
                        <SubCustomDropdown dropdownTitle="Is WIOA Eligible" name="isSubsidyEligible" value={this.state.isSubsidyEligible} options={this.state.subsidyEligibleOptions} optionSubKey={null} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>
                        <SubCustomDropdown dropdownTitle="Cohort" name="cohort" value={this.state.cohort} options={this.state.cohortOptions} optionSubKey={null} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>

                        {/*
                        <SubCustomDropdown dropdownTitle="Created After" name="createdAfter" value={this.state.createdAfter} options={this.state.isCompletedOptions} optionSubKey={null} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>
                        <SubCustomDropdown dropdownTitle="Created Before" name="createdBefore" value={this.state.createdBefore} options={this.state.isCompletedOptions} optionSubKey={null} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>
                        */}
                        <div className="clear" />
                        <div className="spacer" />

                        <br/>
                        {/*
                        <hr className="cell-separator-advisor"/>

                        <div className="top-padding-15">
                          <p>Sort</p>
                        </div>

                        <div className="spacer" />

                        <SubCustomDropdown dropdownTitle="Event Date" name="eventDate" value={this.state.eventDate} options={this.state.sortOptions} optionSubKey={null} optionClass="float-left curtail-text relative-position z-index-1" formChangeHandler={this.formChangeHandler}/>

                        <div className="spacer" />

                        <hr className="cell-separator-advisor"/>*/}
                      </div>
                    </div>
                  )}
                </div>

                {(this.state.filteredEnrollments.length > 0 && !this.state.filtered) && (
                  <div className="width-85-percent top-margin-2-percent max-width-1400 center-horizontally">
                    <div className="top-margin-2-percent">
                      <div className="relative-column-20">
                        <button className={(this.state.pageNumber === 1) ? "background-button full-width left-text wash-out-2" : "background-button full-width left-text"} disabled={(this.state.pageNumber === 1) ? true : false} onClick={() => this.movePage(false)}>
                          <div className="fixed-column-20">
                            <div className="mini-spacer" /><div className="mini-spacer" /><div className="mini-spacer" /><div className="mini-spacer" />
                            <img src={arrowIndicatorIcon} alt="GC" className="image-auto-15 rotate-180" />
                          </div>
                          <div className="calc-column-offset-20">
                            <p className="full-width left-text">Previous</p>
                          </div>
                          <div className="clear" />
                        </button>
                      </div>
                      <div className="relative-column-60">
                        <p className="full-width center-text">{this.state.pageCountStart} - {(this.state.pageCountEnd < this.state.enrollmentCount) ? this.state.pageCountEnd : this.state.enrollmentCount} of {this.state.enrollmentCount}</p>
                      </div>
                      <div className="relative-column-20">
                        <button className={(this.state.pageCountEnd === this.state.enrollmentCount) ? "background-button full-width right-text wash-out-2" : "background-button full-width right-text"} disabled={(this.state.pageCountEnd === this.state.enrollmentCount) ? true : false} onClick={() => this.movePage(true)}>
                          <div className="calc-column-offset-20">
                            <p className="full-width right-text">Next</p>
                          </div>
                          <div className="fixed-column-20 right-text">
                            <div className="mini-spacer" /><div className="mini-spacer" /><div className="mini-spacer" /><div className="mini-spacer" />
                            <img src={arrowIndicatorIcon} alt="GC" className="image-auto-15 pin-right" />
                          </div>
                          <div className="clear" />
                        </button>
                      </div>
                      <div className="clear" />
                    </div>
                  </div>
                )}

                {(this.state.isLoading) ? (
                  <div className="width-85-percent top-margin-2-percent max-width-1400 center-horizontally card">
                    <div className="full-width center-text">
                      <img src={loadingGIF} alt="GC" className="image-auto-80 center-horizontally"/>
                      <div className="spacer" /><div className="spacer"/><div className="spacer"/>
                      <p className="full-width center-text cta-color bold-text">Retrieving info...</p>
                    </div>
                  </div>
                ) : (
                  <div className="width-85-percent top-margin-2-percent max-width-1400 center-horizontally card-clear-padding">
                    <div>
                      <div>
                        <div className=" white-background table-container standard-border medium-shadow">
                          <table className={"default-table"}>
                            <colgroup>
                              <col style={{ width: '40px' }} />
                              <col />
                              <col />
                              <col />
                              <col />
                              <col />
                              <col />
                              <col />
                              <col />
                              <col />
                              <col />
                            </colgroup>
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Course/Program Name</th>
                                <th>Category</th>
                                <th>Provider</th>
                                <th>Stage</th>
                                <th>Cohort</th>
                                <th>Case Manager</th>
                                <th>Is WIOA Eligible</th>
                                <th>Created At</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.renderEnrollments()}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {/*
                    {(this.state.showModule) ? (
                      <div>
                        <div>
                          <div className=" white-background table-container standard-border medium-shadow top-margin-20">
                            <table className={"default-table"}>
                              <colgroup>
                                <col style={{ width: '40px' }} />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Name</th>
                                  <th>Email</th>
                                  <th>Course/Program Name</th>
                                  <th>Course/Program Category</th>
                                  <th>Stage</th>
                                  <th>Is WIOA Eligible</th>
                                  <th>Cohort</th>
                                  <th>Course/Program School Name</th>
                                  <th>Case Manager</th>
                                  <th>Created At</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.renderEnrollments()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        {this.renderEnrollments()}
                      </div>
                    )}*/}
                  </div>
                )}

                <Modal
                 isOpen={this.state.modalIsOpen}
                 onAfterOpen={this.afterOpenModal}
                 onRequestClose={this.closeModal}
                 className="modal"
                 overlayClassName="modal-overlay"
                 contentLabel="Example Modal"
                 ariaHideApp={false}
               >
                  {(this.state.showEditEnrollment) && (
                    <div key="showEditEnrollment" className="full-width padding-20">
                      <SubEditEnrollment closeModal={this.closeModal} selectedEnrollment={this.state.selectedEnrollment}
                      selectedProfile={this.state.selectedProfile} passData={this.passData}
                      />
                    </div>
                  )}
               </Modal>
              </div>
            ) : (
              <div>
                  <h2>Welcome to Guided Compass!</h2>
              </div>
            )}
          </div>

      )
    }
}

export default withRouter(Enrollments);
